import $ from 'jquery';
window.$ = window.jQuery = $;
require('popper.js');
require('./bootstrap');
require('pace');
require('perfect-scrollbar');
//require('@coreui/coreui');
import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip
} from 'chart.js';

Chart.register(
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip
);
window.Chart = Chart;
require('./declaration_upload');
require('./notify');
require('bootstrap-select');
require('js-yaml');
require("gridstack/dist/gridstack.all");
import 'jquery-ui/ui/widgets/datepicker.js';
require('./menu');
require("jquery-mousewheel");
require('malihu-custom-scrollbar-plugin');
require('owl.carousel');
require('./jquery.transfer');
require('./jquery.numeric');
window.moment = require('moment-timezone');
import Stack from './stack';
require('selectize');
window.ifvisible = require('ifvisible.js');

// Date picker from jquery-ui
import 'jquery-ui/ui/widgets/datepicker.js';
$('.datepicker').datepicker();
window.agGrid = require('ag-grid-enterprise/dist/ag-grid-enterprise.js');
window.pusher = require('pusher-js');
window.jstree = require("jstree");
import Echo from "laravel-echo";
// window.websocketOptions = {
//     broadcaster: 'reverb',
//     key: process.env.VITE_REVERB_APP_KEY,
//     // cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     wsHost: process.env.VITE_REVERB_HOST,
//     wsPort: process.env.VITE_REVERB_PORT,
//     wssPort: process.env.VITE_REVERB_PORT,
//     forceTLS: process.env.VITE_REVERB_SCHEME==='https',
//     scheme: process.env.VITE_REVERB_SCHEME,
//     // encrypted: process.env.MIX_PUSHER_FORCE_TLS==='true',
//     disableStats: true,
//     enabledTransports: ["ws", "wss"]
// }
window.websocketOptions = {
    broadcaster: 'reverb',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: process.env.MIX_PUSHER_SCHEME==='https',
    enabledTransports: ["ws", "wss"]
}
window.Echo = Echo;
window.agGrid.LicenseManager.setLicenseKey(process.env.MIX_AG_GRID_KEY);
window.jstree = require("jstree");
window.flowchart = require("flowchart.js");
require("inputmask/dist/jquery.inputmask.min.js");
import * as monaco from 'monaco-editor';
import { configureMonacoYaml } from 'monaco-yaml';
window.monaco = monaco;
window.configureMonacoYaml = configureMonacoYaml;
window.MonacoEnvironment = {
    getWorker(moduleId, label) {
        switch (label) {
            case 'editorWorkerService':
                return new Worker(new URL('monaco-editor/esm/vs/editor/editor.worker', import.meta.url))
            case 'css':
            case 'less':
            case 'scss':
                return new Worker(new URL('monaco-editor/esm/vs/language/css/css.worker', import.meta.url))
            case 'handlebars':
            case 'html':
            case 'razor':
                return new Worker(
                    new URL('monaco-editor/esm/vs/language/html/html.worker', import.meta.url)
                )
            case 'json':
                return new Worker(
                    new URL('monaco-editor/esm/vs/language/json/json.worker', import.meta.url)
                )
            case 'javascript':
            case 'typescript':
                return new Worker(
                    new URL('monaco-editor/esm/vs/language/typescript/ts.worker', import.meta.url)
                )
            case 'yaml':
                return new Worker(new URL('monaco-yaml/yaml.worker', import.meta.url))
            default:
                throw new Error(`Unknown label ${label}`)
        }
    }
}
window.JSONEditor = require('@json-editor/json-editor').JSONEditor;
window.Resumable = require('resumablejs/resumable');
window.Panzoom = require('@panzoom/panzoom').default;
window.pdfjsLib = require('pdfjs-dist/build/pdf.min.mjs');

// Function to apply styles to elements with class starting with 'ace-'
function applyStylesToAceElements(element) {
    var imageName = element.getAttribute('data-image');

    if(imageName == null) {
        element.classList.forEach((className) => {
            if (className.startsWith('ace-')) {
                imageName = className.replace('ace-', '');
            }
        });
    }
    const imagePath = `/images/ace/icons/${imageName}.svg`;

    element.style.mask = `url('${imagePath}') no-repeat center`;
    element.style.webkitMaskImage = `url('${imagePath}')`;
    element.style.webkitMaskRepeat = 'no-repeat';
    element.style.webkitMaskPosition = 'center';
    element.style.opacity = 1;
}

// Observe changes in the DOM
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.matches('i.ace') || node.matches('a.ace'))) {
                applyStylesToAceElements(node);
            } else if (node.nodeType === 1 && node.querySelectorAll) {
                node.querySelectorAll('i.ace, a.ace').forEach(applyStylesToAceElements);
            }
        });
    });
});

// Run initially for existing elements
document.querySelectorAll('i.ace, a.ace').forEach(applyStylesToAceElements);

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// $("document").ready(function() {
//
//     document.querySelectorAll('i.ace').forEach((element) => {
//         var imageName = element.getAttribute('data-image');
//
//         if(imageName == null) {
//             element.classList.forEach((className) => {
//                 if (className.startsWith('ace-')) {
//                     imageName = className.replace('ace-', '');
//                 }
//             });
//         }
//         const imagePath = `/images/ace/icons/${imageName}.svg`;
//
//         element.style.mask = `url('${imagePath}') no-repeat center`;
//         element.style.webkitMaskImage = `url('${imagePath}')`;
//         element.style.webkitMaskRepeat = 'no-repeat';
//         element.style.webkitMaskPosition = 'center';
//         element.style.opacity = 1;
//     });
//
// });
